module.exports = "https://static.wmbcdn.com/uniweb/images/a5e48eba18a42214c4c83a3b3acb831b.svg";